import { TopConfig } from '../context/ConfigContext';
import { PetClaimsData } from '../types/services';
import axios, { AxiosResponse } from 'axios';

export const getPetClaimsServiceConfig = async (topConfig: TopConfig) => {
    const { petClaims: petClaimsServiceConfig } = topConfig.services.animals;
    const { url, method, headers } = petClaimsServiceConfig;

    if (!url) {
        throw new Error('Pet Claim Service: Url not defined');
    }

    try {
        const response: AxiosResponse<PetClaimsData[]> = await axios(url, {
            method,
            headers
        });

        if (response.status === 200) {
            if ('serviceErrors' in response.data) {
                return undefined;
            } else {
                return response.data;
            }
        } else {
            return undefined;
        }
    } catch {
        // @TODO
        //  - Log that petclaim service malfunctioned
        throw new Error('Failed contacting the ClaimComs API');
    }
};
